import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getMessaging } from "firebase/messaging";

// Your web app's Firebase configuration from environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Debug logging for environment verification
console.log('🔑 Firebase Config Debug:', {
  apiKey: firebaseConfig.apiKey ? `${firebaseConfig.apiKey.substring(0, 20)}...` : 'MISSING',
  projectId: firebaseConfig.projectId,
  authDomain: firebaseConfig.authDomain,
  currentHost: window.location.hostname,
  currentOrigin: window.location.origin
});

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Firebase Cloud Messaging needs a secure context (HTTPS or localhost) with
// service-worker support. Over plain HTTP on an IP address (e.g. tailnet/LAN
// access) those browser APIs are unavailable and getMessaging() throws, which
// would crash this whole module. Guard it so the app degrades gracefully —
// push notifications are simply disabled in that case.
let messaging = null;
try {
  if (window.isSecureContext && "serviceWorker" in navigator) {
    messaging = getMessaging(app);
  } else {
    console.warn(
      "Firebase Messaging disabled: not a secure context (needs HTTPS or localhost)."
    );
  }
} catch (err) {
  console.warn("Firebase Messaging unavailable:", err?.message || err);
}
export { messaging };

export default app;
